import * as yup from 'yup'

/**
 * Mirrors the backend `UpdateRetryConfigTemplateDto`: all three fields are `@IsOptional
 * @IsPositive`. This form always sends all three, so they are required here regardless of the
 * DTO's optionality — but `@IsPositive` itself is enforced exactly: strictly greater than zero,
 * so `0` is rejected the same way the API would reject it (`.positive()`, not `.min(0)`).
 *
 * `.integer()` is NOT from the DTO — `@IsPositive` alone would accept `2.5`. It comes from the
 * database: all three are `@Column({ nullable: false })` on a `number` in
 * `RetryConfigTemplateEntity`, which TypeORM maps to an INTEGER column, so a fractional value
 * would be truncated or rejected by Postgres after passing DTO validation. Rejecting it here
 * gives the admin a field-level message instead of an opaque 500.
 *
 * The `transform` mirrors `AiReviewConfigForm.validator.ts`'s pattern: a cleared MUI number
 * input leaves `''` in Formik state, and `yup.number()` would otherwise cast that to `NaN` and
 * fail with a type error instead of the friendlier required message.
 */
export const updateRetryTemplateValidator = yup.object({
  maxAttempts: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .typeError('Enter a number')
    .integer('Must be a whole number')
    .positive('Must be greater than 0')
    .required('Required'),

  backoffMultiplier: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .typeError('Enter a number')
    .integer('Must be a whole number')
    .positive('Must be greater than 0')
    .required('Required'),

  timeoutMinutes: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .typeError('Enter a number')
    .integer('Must be a whole number')
    .positive('Must be greater than 0')
    .required('Required'),
})
